import { CheckBox, Spacer } from '@jfs/ui-new'
import { ChangeEmailId } from '../../comps/ChangeEmaiId'
import { ChangeMobileNumber } from '../../comps/ChangeMobileNumber'
import { ResendOtp } from '../../comps/ResendOtp'
import { TextInputWithLabelOnBorder } from '../../comps/TextInputWithLabelOnBorder'
import { getString } from '../../util/languageStrings'
import { Colors, isOsMobile, logEvent, otp } from '../../util/util'
import { email, mobileNumber, password } from '../../util/validations'
import { OtpTextInput } from '../Otp/OtpTextInput'
import { ApiError } from './LoginCard/ApiError'
import ForgotPassword from './LoginCard/ForgotPassword'

export const loginForm = (
  getEyeRightView: any,
  showPassword: boolean,
  isLoading: boolean,
  leftComponent: any,
  handleLoginPress: any,
  onChangeMobilePress: any,
  error: any,
  showError: boolean,
  mobileNumberRef: any,
  passwordRef: any,
  selectedAppLanguage: any,
  onResendOTPPress: any,
  isResendOtpLoading: any,
  onAutoOTPFilled: any,
): any => [
  {
    key: 'mobile',
    formItems: [
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        size: 16,
      },
      {
        fieldName: 'mobileNumber',
        ComponentName: TextInputWithLabelOnBorder,
        minHeight: 56,
        //autoFocus: true,
        leftComponent: leftComponent,
        testID: 't-mobile',
        accessibilityLabel: 't-mobile',
        validationSchema: mobileNumber,
        maxLength: 10,
        inputMode: 'numeric',
        label: getString(selectedAppLanguage, 'mobileNumber'),
        innerRef: mobileNumberRef,
        selectionColor: Colors.PRIMARY,
        type: 'NUM_ONLY',
      },
      {
        fieldName: 'otpLogin',
        ComponentName: CheckBox,
        textLabel: getString(selectedAppLanguage, 'loginUsingOtp'),
        fontSize: 14,
        textColor: 'BLACK_75',
        hide: !isOsMobile(),
      },
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        size: 8,
      },
    ],
    actionTitle: getString(selectedAppLanguage, 'continue'),
    onSubmit: () => {
      console.log('move to nxt step')
      logEvent('btn_press', 'continue_login')
      setTimeout(() => {
        if (passwordRef?.current && !passwordRef.current?.isFocused()) {
          passwordRef.current?.focus()
        }
      }, 300)
    },
  },
  {
    key: 'password',
    actionTitle: 'Login',
    formItems: [
      {
        fieldName: 'changeMobileNumber',
        ComponentName: ChangeMobileNumber,
        testID: 't-changemobileNumber',
        accessibilityLabel: 't-changemobileNumber',
        onPress: onChangeMobilePress,
      },
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 16,
      },
      {
        fieldName: 'password',
        ComponentName: TextInputWithLabelOnBorder,
        //autoFocus: true,
        testID: 't-password',
        accessibilityLabel: 't-password',
        label: getString(selectedAppLanguage, 'password'),
        validationSchema: password,
        hideText: showPassword ? false : true,
        rightComponent: getEyeRightView,
        displayName: 'Password',
        secureTextEntry: showPassword ? false : true,
        returnKeyType: 'done',
        fontSize: 16,
        height: 48,
        labelFontSize: 14,
        lineHeight: 24,
        innerRef: passwordRef,
        selectionColor: Colors.PRIMARY,
        maxLength: 35,
        //letterSpacing: 6
      },
      {
        fieldName: 'apiError',
        ComponentName: ApiError,
        testID: 't-api-error',
        showError: showError,
        error: error,
      },
      {
        fieldName: 'forgotPwdView',
        ComponentName: ForgotPassword,
        selectedAppLanguage: selectedAppLanguage,
        showError: showError,
        btnLoading: isLoading,
      },
      {
        fieldName: 'spacer2',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 14,
      },
    ],

    onSubmit: (values) => handleLoginPress(values),
  },
  {
    key: 'otpLogin',
    actionTitle: 'Login',
    formItems: [
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 8,
      },
      {
        fieldName: 'changeMobileNumber',
        ComponentName: ChangeMobileNumber,
        testID: 't-changemobileNumber',
        accessibilityLabel: 't-changemobileNumber',
        onPress: onChangeMobilePress,
      },
      {
        fieldName: 'otp',
        ComponentName: OtpTextInput,
        inputType: 'box',
        validationSchema: otp,
        label: 'Enter Otp',
        returnKeyType: 'done',
        fontSize: 16,
        labelFontSize: 14,
        lineHeight: 24,
        selectionColor: Colors.PRIMARY,
        onAutoOTPFilled,
      },
      {
        fieldName: 'spacer2',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 24,
      },
      {
        fieldName: 'forgotPwdView',
        ComponentName: ResendOtp,
        onResendOTPPress,
        showLoader: isResendOtpLoading,
      },
      {
        fieldName: 'spacer2',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 14,
      },
    ],

    onSubmit: () => {},
  },
]

export const getEmailLoginFormData = ({ onChangeEmailPress }) => [
  {
    key: 'mobile',
    formItems: [
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        size: 16,
      },
      {
        fieldName: 'email',
        ComponentName: TextInputWithLabelOnBorder,
        minHeight: 56,
        //autoFocus: true,
        validationSchema: email,
        maxLength: 50,
        label: 'Email Id',
        selectionColor: Colors.PRIMARY,
      },
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        size: 8,
      },
    ],
    actionTitle: 'Send Otp',
  },
  {
    key: 'password',
    actionTitle: 'Login',
    formItems: [
      {
        fieldName: 'changeEmailId',
        ComponentName: ChangeEmailId,
        onPress: onChangeEmailPress,
      },
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 16,
      },
      {
        fieldName: 'otp',
        ComponentName: OtpTextInput,
        inputType: 'bottomline',
        validationSchema: otp,
        label: 'Enter Otp',
        returnKeyType: 'done',
        fontSize: 16,
        labelFontSize: 14,
        lineHeight: 24,
        selectionColor: Colors.PRIMARY,
      },

      {
        fieldName: 'spacer2',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 14,
      },
    ],
  },
]
